import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class Measure extends BasicEntity {
allowNegative: boolean | null;
code: string;
color: string;
connect: Object;
dataKind: string;
defaultAgg: string;
defaultValue: string;
description: TranslatedEmb;
editRegex: string;
editRestrict: string;
editRestrictMessage: TranslatedEmb;
editable: boolean | null;
formatCode: string;
formulaF: string;
formulaI: string;
formulaOverride: boolean | null;
formulaS: string;
formulaT: string;
label: TranslatedEmb;
linkedRef: Object;
maxValue: string;
minValue: string;
mode: string;
nbDecimal: number | null;
settings: Object;
stepLevel: number | null;
styleCode: string;
triggerValue: string;
upper: boolean | null;
useLocale: boolean | null;
valueControl: string;
valueControlMessage: TranslatedEmb;
vid: number | null;
vision: string;
}

